import { Box, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { SalesOrderItemsColumns } from "../../../data/DynamicTable/Collumns";
import { salesManagement } from "../../../config";
import { add } from "lodash";

function PurchaseOrderItemsTable() {
  const navigate = useNavigate(); // Initialize navigate hook
  const data = JSON.parse(localStorage.getItem("SaleOrderData"));
  let stored = JSON.parse(localStorage.getItem("saleSettings") || "[]");
   if (typeof stored === "string") stored = JSON.parse(stored);
      const settings = Array.isArray(stored) ? stored : [];
      const isSettingTrue = (entryOrder) => {
        const setting = settings.find(
          (s) => (s.EntryOrder ?? s.entryOrder) === entryOrder,
        );
        const value = setting?.Value ?? setting?.value;
        return value?.toString().toLowerCase() === "true";
      };
  const base_url = salesManagement.uri;
  let newActions = {
    entity: "PurchaseOrderItems",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    RemoveSaleOrderItem: {
      key: "REMOVESALEORDERITEM",
      button_name: "RemoveSaleOrderItem",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    showMore: {
      key: "SHOWMORE",
      button_name: "Show More",
      Show_Button: true,
      permission: "EditPermission",
      title: "Sale Order Items",
    },
    reversesaleOrderItem: {
      key: "Reverse Sale Order",
      button_name: "Reverse Transaction",
      ModuleNames: "reverseSaleOrder",
      inputObjectName: "reverseInventoryAfterSale",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
     addMpesaCode: {
      key: "Add Mpesa Code",
      button_name: "Add Mpesa Code",
      ModuleNames: "addMpesaCode",
      inputObjectName: "addMpesaCode",
      Show_Button: isSettingTrue(3) ? true : false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
  };

  if (data?.isReversed === true) {
    newActions = {
      entity: "PurchaseOrderItems",
      isSubRight: true,
      showMore: {
        key: "SHOWMORE",
        button_name: "Show More",
        Show_Button: true,
        permission: "EditPermission",
        title: "Sale Order Items",
      },
    };
  }
  const actions = {
    entity: "PurchaseOrderItems",
    isSubRight: true,
    ...newActions,
    dataObject: {
      inputFields: {
        saleOrder: data.saleOrderId,
        // ...(data?.isReversed && { reversed: 1 }),
      },
      inputObjectName: "saleOrderItemViewById",
      inputSubObjectName: "saleOrderItemView",
      returnFields: [
        "id",
        "saleOrder",
        "customerId",
        "customerName",
        "productId",
        "productName",
        "productCode",
        "netAmount",
        "amount",
        "uomId",
        "unitofMeasure",
        "quantity",
        "companyId",
        "companyName",
        "createdBy",
        "updatedBy",
        "createdDate",
        "updatedDate",
        "cashier",
        "color",
        "size",
        "saleDate",
        "reversed",
          ...(isSettingTrue(3) ? ["mpesaCode"] : []),
      ],
    },
    showStatus: true,
  };

  const ignore = ["isActive", "comapnyId", "customerId"];
  return (
    <Box m="2px">
      {/* Back Button */}
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate(-1)} // Go back to the previous page
        sx={{ marginBottom: "10px" }}
      >
        Back
      </Button>
      <>
        <DynamicTable
          title="Sale Order Items"
          subtitle="Create, view or edit sale order Items"
          ignoreFields={ignore}
          // FormComponent={PurchaseOrderItemsForm}
          columns={SalesOrderItemsColumns}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default PurchaseOrderItemsTable;
